// extracted by mini-css-extract-plugin
module.exports = {"main":"Overlay_main__4QEWM","main--visible":"Overlay_main--visible__5ApSJ","search-fade-in":"Overlay_search-fade-in__EY42L"};